module.exports = __webpack_public_path__ + "static/media/refresh-colored.ccf13ba2.svg";